<script>
import Course from "./Course";

export default {
  extends: Course,
  data() {
    return {
     
    };
  },
  computed: {
  },
  methods: {
    init () {
      const token = this.$route.query.token || this.$getCookie('supplier_token')
        if (token) {
            this.$store.dispatch("getAllCourses", token).then(() => {
                const id = this.$route.params.id
                this.$store.dispatch('getCourseById', id)
            });

            this.$store.dispatch("setSupplierToken", token);
        }
    },
    next() {
      this.course_step++;
    },
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content figure:not(:last-child) {
  margin-bottom: 0px;
}
.content li + li {
  margin-top: 0;
}
#course {
  -webkit-overflow-scrolling: touch;
}
@media screen and (min-width: 1024px) {
  .paginate-bar {
    max-width: 960px;
  }

  #course {
    max-width: 960px;
    margin: 0 auto;
  }
}

.step-content {
  padding: 0 !important;
}
.breadcrumb li + li::before {
  content: "";
}
.media {
  align-items: center;

  img {
    width: 18px;
    height: 18px;
  }
}
.paginate-bar {
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  background-color: #142246;

  .paginate-bar__content {
    display: flex;
    justify-content: space-between;

    a {
      color: white;
      line-height: 20px;
      padding: 20px 15px;

      img {
        margin-right: 5px;
      }
      span {
        font-size: 13px;
      }
    }

    .next-step {
      width: 160px;
      height: 40px;
      font-weight: 500;
      margin: 10px;
    }
  }
}

.next-step.d-none {
  display: none;
}
.breadcrumb {
  height: 48px;
  padding: 12px 20px;
  background-color: white;
  margin-bottom: 12px;

  .arrow {
    margin: 0 16px;
  }
  .media-left {
    margin-right: 5px;
  }

  .media-content {
    .content {
      display: inline-block;
    }
    p {
      font-size: 14px;
      // display: none;
      color: #bcbcbc;
    }
    p.bolder {
      font-weight: 500;
      display: block;
      color: #ff8200;
    }
  }
}

@media only screen and (max-width: 600px) {
  .course {
    height: 100vh;
  }
}
@media only screen and (min-width: 601px) {
  .course {
    .video {
      height: calc(100vh - 140px);
    }
  }
}
</style>
